// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NewConfigurationSection_StructureFragmentDoc } from './NewConfigurationSection.generated';
import { ReadyPlanConfigCard_ReadyPlanConfigLikeFragmentDoc, ReadyPlanConfigCard_ReadyPlanOptionFragmentDoc } from './ReadyPlanConfigCard.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SelectConfigurationStepQueryVariables = Types.Exact<{
  structureId: Types.Scalars['ID']['input'];
}>;


export type SelectConfigurationStepQuery = { __typename?: 'Query', structure: { __typename?: 'Structure', id: string, isAdu: boolean, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, name?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, maybeShortName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, forDesignPackages: boolean } }>, productOffering?: { __typename?: 'ProductOffering', id: string } | null | undefined, programData?: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined, widthInFeet?: number | null | undefined, depthInFeet?: number | null | undefined } | null | undefined } | null | undefined } };


export const SelectConfigurationStepDocument = gql`
    query SelectConfigurationStep($structureId: ID!) {
  structure(id: $structureId) {
    ...NewConfigurationSection_Structure
    readyPlanConfig {
      readyPlanOptions {
        ...ReadyPlanConfigCard_ReadyPlanOption
      }
      ...ReadyPlanConfigCard_ReadyPlanConfigLike
    }
  }
}
    ${NewConfigurationSection_StructureFragmentDoc}
${ReadyPlanConfigCard_ReadyPlanOptionFragmentDoc}
${ReadyPlanConfigCard_ReadyPlanConfigLikeFragmentDoc}`;

/**
 * __useSelectConfigurationStepQuery__
 *
 * To run a query within a React component, call `useSelectConfigurationStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectConfigurationStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectConfigurationStepQuery({
 *   variables: {
 *      structureId: // value for 'structureId'
 *   },
 * });
 */
export function useSelectConfigurationStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectConfigurationStepQuery, SelectConfigurationStepQueryVariables> & ({ variables: SelectConfigurationStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectConfigurationStepQuery, SelectConfigurationStepQueryVariables>(SelectConfigurationStepDocument, options);
      }
export function useSelectConfigurationStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectConfigurationStepQuery, SelectConfigurationStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectConfigurationStepQuery, SelectConfigurationStepQueryVariables>(SelectConfigurationStepDocument, options);
        }
// @ts-ignore
export function useSelectConfigurationStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectConfigurationStepQuery, SelectConfigurationStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectConfigurationStepQuery, SelectConfigurationStepQueryVariables>;
export function useSelectConfigurationStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectConfigurationStepQuery, SelectConfigurationStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectConfigurationStepQuery | undefined, SelectConfigurationStepQueryVariables>;
export function useSelectConfigurationStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectConfigurationStepQuery, SelectConfigurationStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectConfigurationStepQuery, SelectConfigurationStepQueryVariables>(SelectConfigurationStepDocument, options);
        }
export type SelectConfigurationStepQueryHookResult = ReturnType<typeof useSelectConfigurationStepQuery>;
export type SelectConfigurationStepLazyQueryHookResult = ReturnType<typeof useSelectConfigurationStepLazyQuery>;
export type SelectConfigurationStepSuspenseQueryHookResult = ReturnType<typeof useSelectConfigurationStepSuspenseQuery>;
export type SelectConfigurationStepQueryResult = ApolloReactCommon.QueryResult<SelectConfigurationStepQuery, SelectConfigurationStepQueryVariables>;